import { useMutation, useQuery } from 'react-query';
import portoScheduleServices from './porto-schedule.services';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';
import { notification } from 'antd';
import { isAppPortocar } from '@/index';
import { AxiosError } from 'axios';
import { PortoScheduleAvailabilityRequest } from './porto-schedule.types';
import { WORKORDER_COMPLEMENT_DETAIL_KEY } from '../WorkOrdersComplements/WorkOrdersComplements.hooks';

const QUERY_PORTO_SCHEDULE_CONFIGURATION_LIST = 'porto/schedule-configuration';
const QUERY_PORTO_SCHEDULE_AVAILABLITY = 'porto/schedule-availability';

export function usePortoScheduleConfigurationList(capsCode?: string) {
  return useQuery({
    queryKey: [QUERY_PORTO_SCHEDULE_CONFIGURATION_LIST, capsCode],
    queryFn: () => portoScheduleServices.scheduleConfigurationList(capsCode),
    enabled: !!capsCode && isAppPortocar,
    onError(error: AxiosError) {
      if (error.isAxiosError && error.response?.status !== 404) {
        notificationError(error);
      }
    },
  });
}

export function usePortoScheduleConfigurationAdd() {
  return useMutation({
    mutationFn: portoScheduleServices.scheduleConfigurationAdd,
    async onSuccess(_, vars) {
      notification.success({
        message: 'Configuração de serviço de agendamento salvo com sucesso!',
      });
      await queryClient.invalidateQueries({
        queryKey: [QUERY_PORTO_SCHEDULE_CONFIGURATION_LIST, vars.capsCode],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function usePortoScheduleAvailability(
  params: PortoScheduleAvailabilityRequest,
  enabled = true,
) {
  return useQuery({
    queryKey: [QUERY_PORTO_SCHEDULE_AVAILABLITY, { ...params }],
    queryFn: () => portoScheduleServices.availability(params),
    enabled:
      enabled &&
      !!params?.availabilityDate &&
      !!params.capsCodes.length &&
      isAppPortocar,
    onError(error: AxiosError) {
      if (error.isAxiosError && error.response?.status !== 404) {
        notificationError(error);
      }
    },
  });
}

export function usePortoScheduleUpdate() {
  return useMutation({
    mutationFn: portoScheduleServices.update,
    async onSuccess() {
      notification.success({
        message: 'Data do agendamento alterada com sucesso!',
      });

      await queryClient.invalidateQueries({
        queryKey: [QUERY_PORTO_SCHEDULE_AVAILABLITY],
      });

      await queryClient.resetQueries({
        queryKey: [WORKORDER_COMPLEMENT_DETAIL_KEY],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
